import React from "react";
import styles from "./index.module.scss";
import { Nav, NavDropdown } from "react-bootstrap";
import { AssetStore } from "../../assets/AssetsStore";
import { Button, Popover } from "antd";
import { useState } from "react";

function DashboardAvatar(props) {
  const [open, setOpen] = useState(false);
  
  const hide = () => {
    setOpen(false);
  };
  
  const handleOpenChange = (newOpen) => {
    setOpen(newOpen);
  };

  const userData = JSON.parse(localStorage.getItem("userData"));
  console.log('user data', userData?.profileImage || 'https://www.connect2mydoctor.com/assets/img/doctor-avatar.jpg');

  return (
    <div className={styles.avatarContainer}>
      {/* <Nav>
        <>
          <NavDropdown
            title={
              <button className={styles.action_btn}>
                <img src={AssetStore.dashbaodrV2.help} alt="" />
              </button>
            }
            id="basic-nav-dropdown"
          >
            <NavDropdown.Item
              className={styles.nav_item}
              onClick={(e) => {
                // handleHelpMenuClick({
                //   option: "email",
                //   value: "Dummymail@gmail.com",
                // });
              }}
            >
              <div className={styles.item}>
                <div className={styles.title}>
                  <img src={AssetStore.dashbaodrV2.mail} alt="" />
                </div>
                <div className={styles.text}>Dummymail@gmail.com</div>
              </div>
            </NavDropdown.Item>

            <NavDropdown.Item
              onClick={(e) => {
                // handleHelpMenuClick({
                //   option: "phone",
                //   value: "+91 9876543210",
                // });
              }}
              className={styles.nav_item}
            >
              <div className={styles.item}>
                <div className={styles.title}>
                  <img src={AssetStore.dashbaodrV2.phone} alt="" />
                </div>
                <div className={styles.text}>
                  <a href="tel:+91 9876543210"> +91 9876543210 </a>
                </div>
              </div>
            </NavDropdown.Item>
            <NavDropdown.Item
              onClick={(e) => {
                // handleHelpMenuClick({ option: "faq" });
              }}
              className={styles.nav_item}
            >
              <div className={styles.item}>
                <div className={styles.title}>
                  <img src={AssetStore.dashbaodrV2.faq} alt="" />
                </div>
                <div className={styles.text}>FAQ</div>
              </div>
            </NavDropdown.Item>
          </NavDropdown>
        </>
      </Nav>

      <button className={styles.action_btn}>
        <img src={AssetStore.dashbaodrV2.logout} alt="" />
      </button> */}
      <Popover
        overlayClassName={styles.userProfilePopover}
        // className={styles.userProfilePopover}
        content={<PopoverContent {...props} />}
        title={false}
        trigger="click"
        open={open}
        placement="bottomRight"
        onOpenChange={handleOpenChange}
      >
        <div className={styles.avaaterImageWrap}>
          <img
            src={userData?.profileImage || 'https://www.connect2mydoctor.com/assets/img/doctor-avatar.jpg'}
            alt="user-avater"
          />
        </div>
      </Popover>
    </div>
  );
}

export default DashboardAvatar;

const PopoverContent = ({ handleHelpMenuClick, handleLogout }) => {
  const userData = JSON.parse(localStorage.getItem("userData"));
  console.log('user data', userData?.profileImage || 'https://www.connect2mydoctor.com/assets/img/doctor-avatar.jpg');
  return (
    <div className={styles.profileContainer}>
      <div className={styles.profileDataWrap}>
        <div className={styles.profileBack}></div>

        <div className={styles.imageBorder}>
          <img
            src={userData?.profileImage || 'https://www.connect2mydoctor.com/assets/img/doctor-avatar.jpg'}
            alt="user-avater"
          />
        </div>

        <h5>{userData?.profileName}</h5>
        <label>{userData?.userName}</label>
      </div>

      <div className={styles.contactDataWrap}>
        

        {handleLogout && (
          <button className={styles.logoutButton} onClick={handleLogout}>
            Logout
          </button>
        )}
      </div>
    </div>
  );
};
